import React from "react";
import CardClass from "../../../CardClass";
import MUITextField from "@mui/material/TextField";
import MUIGrid from "@mui/material/Grid";

export default class CardAdminProviderGeneral extends CardClass {
    constructor(props) {
        super(props);
        this.state = {
            isEditing: !!props.provider, // Initialize based on whether provider is provided
        };
    }

    /**
     * Render the content of the card.
     */
    renderContent() {
        return (
            <MUIGrid container spacing={2}>
           <MUIGrid item xs={12} sm={6} md={4}>
                    <MUITextField
                        value={this.props.provider ? this.props.provider.firstName : ""}
                        autoFocus={true}
                        size="small"
                        label="First Name"
                        variant="standard"
                        fullWidth={true}
                        inputProps={{
                            maxLength: 255,
                        }}
                        InputLabelProps={{ shrink: true }}
                        onBlur={(e) => this.props.onChange({ firstName: e.target.value.trim() })}
                        onChange={(e) => this.props.onChange({ firstName: e.target.value })}
                        required={true}
                        error={this.props.validationIssues.firstName ? true : false}
                        helperText={this.props.validationIssues.firstName ? this.props.validationIssues.firstName : ""}
                    />
                </MUIGrid>
                <MUIGrid item xs={12} sm={6} md={4}>
                    <MUITextField
                        value={this.props.provider ? this.props.provider.lastName : ""}
                        size="small"
                        label="Last Name"
                        variant="standard"
                        fullWidth={true}
                        inputProps={{
                            maxLength: 255,
                        }}
                        InputLabelProps={{ shrink: true }}
                        onBlur={(e) => this.props.onChange({ lastName: e.target.value.trim() })}
                        onChange={(e) => this.props.onChange({ lastName: e.target.value })}
                        required={true}
                        error={this.props.validationIssues.lastName ? true : false}
                        helperText={this.props.validationIssues.lastName ? this.props.validationIssues.lastName : ""}
                    />
                </MUIGrid>
            </MUIGrid>
        );
    }

    /**
     * @returns {string} The title of the card.
     */
    getTitle() {
        return "General";
    }
}